import { useCallback, useEffect, useState } from 'react';
import {
  checkUserRegistration,
  registerUserForTrivia
} from '../services/apiRequests/TriviaService';
import { UsersData } from '../store/interface';
import { setSessionStorage } from '../utils/browserStorageHandler';
import { REDIRECT_URL_TO_CONSUMPTION } from '../utils/constants/localStorageConstants';
import { HeaderLinks } from '../utils/constants/RouterConstants';
import { globalUrlHelper } from '../utils/common';

const GUEST_USER = ['guest', 'User'];

export const useGamificationUserStatus = (gameMapperId: string) => {
  const [showUserDetailsPopup, setShowUserDetailsPopup] =
    useState<boolean>(false);
  const [isUserOnBoarded, setIsUserOnBoarded] = useState<boolean>(false);
  const [showRegisterPopup, toggleRegisterPopup] = useState<boolean>(false);

  const getStartedHandler = async function (
    usersData: UsersData,
    usersLocationData: any
  ) {
    if (
      usersData?.first_name === '' ||
      (usersData?.first_name?.toLowerCase() === GUEST_USER[0] &&
        usersData?.last_name === GUEST_USER[1])
    ) {
      setShowUserDetailsPopup(true);
    } else if (!showUserDetailsPopup) {
      const result = await checkUserRegistration({ mapperId: gameMapperId });
      if (
        result?.isUserRegisteredToGamification?.status &&
        result?.isUserRegisteredToGamification?.hasConsented
      ) {
        setIsUserOnBoarded(true);
      } else {
        const response = await registerUserForTrivia({
          userName: `${usersData?.first_name || ''} ${
            usersData?.last_name || ''
          }`,
          region: usersLocationData?.country || '',
          mapperId: gameMapperId
        });
        if (response?.registerUserToGamification?.userName) {
          setIsUserOnBoarded(true);
        }
      }
    }
  };

  const loginToPlayClickHandler = useCallback(() => {
    toggleRegisterPopup((prevShow) => !prevShow);
  }, []);

  useEffect(() => {
    if (showRegisterPopup) {
      setSessionStorage(
        REDIRECT_URL_TO_CONSUMPTION,
        window.location.pathname + window.location.search
      );
      window.location.href = globalUrlHelper(HeaderLinks.SIGN_IN);
    }
  }, [showRegisterPopup]);

  useEffect(() => {
    if (isUserOnBoarded) {
      setShowUserDetailsPopup(false);
    }
  }, [isUserOnBoarded]);

  return {
    loginToPlayClickHandler,
    getStartedHandler,
    isUserOnBoarded,
    showUserDetailsPopup,
    setIsUserOnBoarded
  };
};
